import { format, isYesterday, isToday, isWithinInterval, getYear, subDays } from "date-fns";
import { getObservableT, i18nGetDateFnsLocale } from "./Infra/i18next";
import { IdentifiedPatientState } from "healthex-common/consent.dtos";
import { AzureChip, EmberChip, ForestChip, SlateChip } from "./UI/HXDesktopChips.styles";
import React from "react";
import { ProjectType } from "healthex-common/study.dtos";
const t = getObservableT("patients");
export const getPatientDateString = (date) => {
    if (!date)
        return "";
    const locale = i18nGetDateFnsLocale();
    const targetDate = new Date(date);
    const now = new Date();
    if (isToday(targetDate)) {
        return t("Today");
    }
    else if (isYesterday(targetDate)) {
        return t("Yesterday");
    }
    else if (isWithinInterval(targetDate, {
        start: subDays(now, 7),
        end: now,
    })) {
        return format(targetDate, "EEEE", { locale });
    }
    else if (getYear(targetDate) === getYear(now)) {
        return format(targetDate, "LLL d", { locale });
    }
    else {
        return format(targetDate, "yyyy-MM-dd", { locale });
    }
};
export function getPatientStatusChip(consent) {
    if (consent.pending) {
        return React.createElement(EmberChip, { label: t("Action needed") });
    }
    switch (consent.state) {
        case IdentifiedPatientState.ENROLLING:
            return React.createElement(EmberChip, { label: t("Action needed") });
        case IdentifiedPatientState.ENROLLING_INTERESTED:
        case IdentifiedPatientState.ENROLLING_CONTACTED:
            return React.createElement(AzureChip, { label: t("Expressed interest") });
        case IdentifiedPatientState.ENROLLED:
            if (consent.updateRecordsNeeded) {
                return React.createElement(ForestChip, { label: t("Agreed · Action needed") });
            }
            else {
                return React.createElement(ForestChip, { label: t("Agreed") });
            }
        case IdentifiedPatientState.DECLINED_ENROLLMENT:
            return React.createElement(SlateChip, { label: t("Declined") });
        case IdentifiedPatientState.REMOVED:
        case IdentifiedPatientState.REVOKED_ENROLLMENT:
            return React.createElement(SlateChip, { label: t("Stopped sharing") });
        default:
            return null;
    }
}
export function getPatientRequestText(projectType) {
    return projectType === ProjectType.GENERAL_DATA_USE ? t("Health record access") : t("Research participation");
}
